const e=Object.freeze({form:"c-login-form"}),o=Object.freeze({heading:"Log into your account"}),r={email:"",password:""};export{e as LOGIN_FORM_BLOCK_CSS_IDENTIFIERS,o as LOGIN_FORM_DEFAULTS,r as LOGIN_FORM_INITIAL_VALUES};
//# sourceMappingURL=LoginForm.constants.js.map
